import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Analytics from '../../Analytics';
import SubscriptionToggle from '../Notifications/SubscriptionToggle/SubscriptionToggle';

class WatchApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: !!props.app.isSubscribable,
      executing: false
    };
  }

  isWatchingApp = () => {
    const {
      app: { subscriptionInfo }
    } = this.props;
    const { inApp } = subscriptionInfo || { inApp: false };
    return inApp;
  };

  subscribe = () => {
    this.props.subscribe();
    Analytics.record('Subscribe', { appId: this.props.app.id });
  };

  unsubscribe = () => {
    this.props.unsubscribe();
    Analytics.record('Unsubscribe', { appId: this.props.app.id });
  };

  ensureButtonState = () => {
    const { disabled, executing } = this.state;
    if (!executing && disabled) this.setState({ disabled: false });
  };

  componentDidMount = () => {
    this.ensureButtonState();
  };

  componentDidUpdate() {
    this.ensureButtonState();
  }

  render() {
    const { app } = this.props;
    const { disabled } = this.state;
    const isWatching = this.isWatchingApp();
    const id = `watch-app-${app.id}`;
    const label = 'Subscribe to Updates?';
    const onChange = isWatching ? this.unsubscribe : this.subscribe;
    return (
      <SubscriptionToggle id={id} label={label} isSubscribed={isWatching} disabled={disabled} onChange={onChange} />
    );
  }
}

WatchApp.propTypes = {
  app: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isSubscribable: PropTypes.bool,
    subscriptionInfo: PropTypes.shape({
      inApp: PropTypes.bool
    })
  }),
  subscribe: PropTypes.func.isRequired,
  unsubscribe: PropTypes.func.isRequired
};

export default WatchApp;
